module.exports = __webpack_public_path__ + "static/img/csr1.4889bc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/csr1.jpg
// module id = gCF7
// module chunks = 1